export default "__VITE_ASSET__C$p6Dlla__";